import { defineFieldDisplay } from "../defines";
import Display from "./display.vue";

export default defineFieldDisplay({
  id: "iframe",
  component: Display,
});
